import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { ChevronUp } from "lucide-react";
import WhatsAppFloat from "./WhatsAppFloat";
import BottomTabBar from "./BottomTabBar";
import ScrollToTop from "./ScrollToTop";

export default function Layout() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setShowTop(window.scrollY > 300);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="text-foreground min-h-screen flex flex-col">
      <ScrollToTop />
      <Header />
      <main className="flex-1 pb-[calc(56px+env(safe-area-inset-bottom))] sm:pb-0">
        <Outlet />
      </main>
      <Footer />

      <WhatsAppFloat />
      <BottomTabBar />

      {/* Back to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className={`fixed bottom-[calc(68px+env(safe-area-inset-bottom))] left-5 sm:bottom-6 z-50 p-3 rounded-full bg-primary text-primary-foreground shadow-lg hover:scale-110 transition-all duration-300 ${showTop ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}
        aria-label="Back to top"
      >
        <ChevronUp className="w-5 h-5" />
      </button>
    </div>
  );
}